import { Button } from "@/components/ui/button";

import type { ErrorCardProps } from "./error-card.types";

export const ErrorCard = (props: ErrorCardProps) => {
  const { title, message, buttonLabel, onButtonClick, className } = props;
  return (
    <div className={className}>
      <div className="p-4">
        <div className="text-center">
          {title && (
            <p className="capitalize font-bold leading-relaxed mb-2">{title}</p>
          )}
          {message && (
            <p className="text-muted-foreground leading-relaxed mb-4">
              {message}
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center justify-center mb-4 p-2">
        <Button onClick={onButtonClick}>{buttonLabel}</Button>
      </div>
    </div>
  );
};
